var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeOutOfReactionChamber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 886.21234,
    height: 1262.9177,
    viewBox: "0 0 886.21234 1262.9177",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeMiterlimit: 1.5
    },
    id: "svg213",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs217"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Get-reactants",
    transform: "matrix(0.829192,0,0,1.09268,-406.40646,-1649.9631)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 937.157,1264.71 c 0,0 -96.428,-206.96 -366.305,-355.796 C 293.098,755.733 543.016,284.156 767.07,500.603",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "83.33px"
    },
    id: "path20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.852766,0.64713,-0.852766,-0.64713,2174.73,1366.64)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 940.991,420.251 1069.11,591.319 H 812.874 Z",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 940.991,420.251 1069.11,591.319 H 812.874 Z",
    id: "path26"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.487682,-0.837014,-1.10299,-0.370083,1694.23,1201.81)",
    id: "g114"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.816886,-0.440358,0.625092,1.15958,-2785.04,-1176.33)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1393.07,2551.06 c 3.34,7.94 -40.95,101.96 -40.95,101.96 0,0 -33.43,20.47 -122.02,27.58 -124.1,53.48 -113.23,54.74 -113.23,54.74 0,0 -45.55,11.7 -41.37,-25.91 49.3,-69.36 93.18,-54.74 93.18,-54.74 0,0 38.02,-30.5 -114.07,-83.57 -109.901,-5.43 -192.163,54.8 -192.163,54.8 0,0 -43.763,7.85 -50.615,0 C 780.493,2608.37 971,2524.32 971,2524.32 c 0,0 62.42,-32.56 138.05,-26.29 85.3,13.24 134.16,20.83 189.63,29.44 31.76,7.94 91.04,15.65 94.39,23.59 z",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1117.99,2733.53 c -0.74,-0.45 -1.58,-0.26 -2.08,-0.06 l -0.44,0.2 0.96,1.77 c -4.65,1.08 -44.87,9.43 -40.93,-26.01 49.3,-69.36 93.18,-54.74 93.18,-54.74 0,0 38.02,-30.5 -114.07,-83.57 -109.901,-5.43 -192.163,54.8 -192.163,54.8 0,0 -43.763,7.85 -50.615,0 C 780.493,2608.37 971,2524.32 971,2524.32 c 0,0 62.42,-32.56 138.05,-26.29 85.3,13.24 134.16,20.83 189.63,29.44 31.76,7.94 91.04,15.65 94.39,23.59 3.34,7.94 -40.95,101.96 -40.95,101.96 0,0 -33.43,20.47 -122.02,27.58 -86.16,37.13 -107.26,49.09 -112.11,52.93 z m -3.16,0.1 c 0.52,-0.76 2.14,-2.33 6.93,-5.15 10.49,-6.15 37.72,-19.77 107.39,-49.8 l 0.36,-0.15 0.4,-0.03 c 81.33,-6.53 115.77,-24.34 120.41,-26.92 2.97,-6.33 28.56,-61.08 37.61,-87.5 1.4,-4.1 2.4,-7.5 2.83,-9.9 0.2,-1.12 0.37,-1.92 0.19,-2.35 -0.27,-0.64 -1.2,-1.13 -2.45,-1.77 -2.69,-1.36 -6.83,-2.71 -11.92,-4.07 -20.53,-5.48 -56.16,-10.92 -78.38,-16.46 0,0 -184.86,-28.7 -189.44,-29.41 -74.87,-6.17 -136.648,26.04 -136.648,26.04 l -0.137,0.06 c 0,0 -121.432,53.51 -154.015,83.88 -3.051,2.85 -5.296,5.45 -6.486,7.79 -0.702,1.38 -1.036,2.62 -0.764,3.71 0.249,1.01 1.04,1.81 2.295,2.52 l 0.34,0.19 0.251,0.29 c 0.592,0.67 1.607,1.12 2.864,1.51 2.45,0.74 5.728,1.07 9.388,1.17 13.618,0.34 32.289,-2.76 35.642,-3.33 6.683,-4.75 87.195,-60.18 193.24,-54.94 l 0.35,0.02 0.32,0.12 c 76.89,26.82 105.6,48.13 115.21,62.55 4.17,6.25 4.93,11.36 4.43,15.22 -0.8,6.18 -4.88,9.36 -4.88,9.36 l -1,0.81 -1.25,-0.42 c 0,0 -42.25,-13.67 -90.21,53.49 -0.67,6.72 0.34,11.72 2.49,15.4 3.43,5.86 9.76,8.21 16.04,9.03 7.73,1 15.47,-0.31 18.6,-0.96 z",
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1003.96,2574.46 -89.336,99.45 c 0,0 22.564,10.87 41.785,-5.85 19.222,-16.71 67.271,-65.18 67.271,-65.18 0,0 10.85,0.3 15.88,1.87 -11.26,10.46 -60.169,64.57 -60.169,64.57 0,0 22.149,9.19 38.859,-5.44 16.72,-14.62 55.58,-39.27 55.58,-39.27 0,0 83.48,6.26 91.42,15.04 2.81,-23.53 -100.43,-73.48 -161.29,-65.19 z",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1003.96,2574.46 -89.336,99.45 c 0,0 22.564,10.87 41.785,-5.85 19.222,-16.71 67.271,-65.18 67.271,-65.18 0,0 10.85,0.3 15.88,1.87 -11.26,10.46 -60.169,64.57 -60.169,64.57 0,0 22.149,9.19 38.859,-5.44 16.72,-14.62 55.58,-39.27 55.58,-39.27 0,0 83.48,6.26 91.42,15.04 2.81,-23.53 -100.43,-73.48 -161.29,-65.19 z m 1.18,1.98 -86.812,96.64 c 6.235,2.12 22.35,5.77 36.529,-6.56 19.188,-16.68 67.153,-65.07 67.153,-65.07 l 0.71,-0.71 1.03,0.03 c 0,0 11.3,0.35 16.53,1.98 l 0.89,3.49 c -9.85,9.15 -48.511,51.71 -57.952,62.12 6.246,1.8 21.382,4.57 33.472,-6.01 16.8,-14.7 55.86,-39.49 55.86,-39.49 l 0.66,-0.42 0.8,0.06 c 0,0 41.05,3.09 68.42,7.96 8.39,1.49 15.51,3.17 19.88,4.95 0.02,0.01 0.04,0.02 0.05,0.03 -0.51,-1.31 -1.3,-2.67 -2.31,-4.09 -3.58,-5 -9.95,-10.48 -18.22,-16.02 -32.62,-21.82 -94.59,-44.21 -136.69,-38.89 z",
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 984.907,2580.65 c -14.625,5.85 -133.797,61.92 -135.05,75.71 14.457,12.45 37.446,10.76 51.347,4.67 24.599,-11.77 98.328,-86.23 83.703,-80.38 z",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 984.907,2580.65 c -14.625,5.85 -133.797,61.92 -135.05,75.71 14.457,12.45 37.446,10.76 51.347,4.67 24.599,-11.77 98.328,-86.23 83.703,-80.38 z m -2.215,3.25 c -18.588,8.08 -88.926,41.44 -118.367,61.55 -4.574,3.13 -8.14,5.91 -10.304,8.22 -0.705,0.75 -1.269,1.41 -1.596,1.99 13.769,10.89 34.86,9.12 47.758,3.49 19.533,-9.38 70.074,-58.44 82.125,-74.71 0.132,-0.18 0.26,-0.36 0.384,-0.54 z",
    id: "path44"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 937.038,634.766 c 0,0 -1.942,-6.061 -4.411,-6.164",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10.111717,2658.8456,-8991.1023)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1037.18,723.061 15.69,-34.51 c 0,0 -23.65,-10.86 -36.44,8.205 -12.79,19.065 -7,21.921 -11.1,26.546 -4.1,4.624 9.41,16.41 31.85,-0.241 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1028.74,628.534 c 0,0 8.75,-9.885 27.76,-6.26",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 768.425,685.471 c 0,0 -4.267,-14.208 -10.041,-18.727",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 758.384,659.464 c 0,0 18.326,19.229 15.313,16.644",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path66"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 861.616,576.402 c 0,0 16.356,3.673 20.572,9.181",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path70"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 879.748,568.598 c 0,0 7.574,11.247 7.345,19.051",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path74"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1031.33,587.649 c 0,0 57.54,-38.39 110.94,-43.279 -68.07,22.187 -98.66,41.366 -98.66,58.664",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path78"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 842.592,717.361 c 0,0 11.898,-0.984 13.574,-5.939",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path82"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.291448,1356.1748,-3978.678)",
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1026.04,692.029 c 0,0 -6.72,7.993 -4.75,10.856 1.98,2.864 -7.59,-6.438 4.75,-10.856 z",
    style: {
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path86"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.853684,0,0,0.711005,-1548.9,-267.209)",
    id: "g92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 862.35,624.244 c 0,0 15.762,14.947 16.305,19.023 0.544,4.077 -4.981,-7.609 -19.068,-8.968",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.65px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path90"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 937.038,636.216 c 0,0 -14.125,-3.105 -14.978,-1.45",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path94"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 793.968,724.9 c 0,0 6.952,5.993 8.511,6.473",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path98"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 792.769,728.136 c 0,0 6.593,8.631 8.151,7.193",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path102"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 842.592,723.897 c 0,0 9.552,-0.431 11.563,-4.968",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path106"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1674.67,-447.612)",
    id: "g112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 870.051,509.663 26.848,10.739 25.383,-23.919",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.08px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path110"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 703.609,511.987 99.535,-101.019 24.024,145.533 c 0,0 -142.709,4.279 -179.918,2.815 164.761,6.486 144.841,-141.206 56.359,-47.329 z",
    style: {
      fill: "#ffffff"
    },
    id: "path116"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 827.168,595.932 647.25,568.65",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "3.45px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path120"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 702.114,490.471 c 0,0 -89.605,-72.312 -180.841,60.148 -91.235,132.459 -33.56,271.002 37.17,321.688 143.381,68.426 263.23,170.813 400.252,369.163",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "8.33px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path124"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 901.51,1271.95 c 0,0 33.283,-12.46 10.586,-69.21 -22.697,-56.74 35.088,45.33 35.088,45.33 z",
    style: {
      fill: "#ffffff"
    },
    id: "path128"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g198"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99023,-0.664177,0.867127,0.744488,979.399,925.019)",
    id: "g168"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.793296,0,0,0.735714,-1853.43,-394.788)",
    id: "g142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g140"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.861898,0.829103,-0.761802,0.938042,1448.77,94.3247)",
    id: "g134"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1213.66,1280.89 -553.339,23.58 v 21.24 l 186.079,231.41 65.696,56.94 43.343,6.06 29.078,-1.21 25.443,14.54 144.17,-102.98 89.66,-88.4 15.75,-36.87 1.21,-67.37 -6.06,-39.19 z",
    style: {
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path132"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.2737)",
    id: "g138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1463.1,1688.12 c 13.94,7.37 26.78,17.28 37.94,29.43 26.53,28.87 41.43,68.03 41.43,108.86 v 506.21 c 0,57.97 -34.2,107.24 -81.85,125.18 1.64,2.38 2.48,4.82 2.48,7.31 0,27.32 -101.33,49.5 -226.15,49.5 -124.82,0 -226.16,-22.18 -226.16,-49.5 0,-2.49 0.84,-4.93 2.48,-7.31 -47.645,-17.94 -81.849,-67.21 -81.849,-125.18 0,-139.55 0,-359.06 0,-506.21 0,-40.83 14.903,-79.99 41.431,-108.86 11.163,-12.15 23.999,-22.06 37.938,-29.43 v -89.34 h 452.31 z m -405.52,802.69 c -0.21,0.34 -0.42,0.69 -0.65,1.03 -0.22,0.35 -0.45,0.69 -0.68,1.03 z m 354.19,-57.28 c -29.14,6.67 -106.19,22.61 -174.82,22.61 -68.64,0 -145.69,-15.94 -174.83,-22.61 -6.04,-14.46 -17.31,-25.72 -31.29,-30.98 -26.61,-10.02 -45.69,-37.55 -45.69,-69.93 0,0 0,-506.21 0,-506.21 0,-25.33 9.244,-49.62 25.7,-67.52 6.89,-7.51 14.82,-13.63 23.43,-18.19 18.5,-9.78 30.24,-30.2 30.24,-52.58 v -30.87 c 0,0 344.87,0 344.87,0 0,0 0,30.87 0,30.87 0,22.38 11.74,42.8 30.24,52.58 8.61,4.56 16.54,10.68 23.44,18.19 16.45,17.9 25.69,42.19 25.69,67.52 v 506.21 c 0,32.38 -19.08,59.91 -45.69,69.93 -13.98,5.26 -25.25,16.52 -31.29,30.98 z",
    id: "path136"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1731.75,-40.6067)",
    id: "g146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1044.98,841.891 -318.551,2.846 1.784,57.789 c 0,0 -61.699,28.742 -62.465,86.225",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "22.92px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path144"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1733.84,-29.6345)",
    id: "g150"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700.78101,
    y: 1053.54,
    width: 14.173,
    height: 144.644,
    id: "rect148"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,1,-1016.09,-112.383)",
    id: "g154"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700.78101,
    y: 1053.54,
    width: 14.173,
    height: 144.644,
    id: "rect152"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.645166,0,0,0.570147,-1464.61,489.064)",
    id: "g158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700.78101,
    y: 1053.54,
    width: 14.173,
    height: 144.644,
    id: "rect156"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1731.75,-40.6067)",
    id: "g162"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1113.41,1305.2 -1.33,50.93 c 0,0 -2.25,48.19 -55.81,78.27",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "15.28px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path160"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.998105,0.062105,0.0609602,0.998105,-46.7705,-93.0172)",
    id: "g166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1113.41,1305.2 -1.33,50.93 c 0,0 -2.25,48.19 -55.81,78.27",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "15.28px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path164"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1277.35,1394.93 c 0,0 -176.34,97.11 -281.627,250.92",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "3.45px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path170"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1018,1645.85 c 231.12,-142.61 232.66,-217.89 242.75,-227.12 6.8,-4.57 16.6,-10.48 16.6,-10.48 -16.6,39.22 -80.09,139.95 -259.35,237.6 z",
    style: {
      fill: "#ffffff"
    },
    id: "path174"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 731.923,1394.93 171.712,172.79 c 0,0 40.729,34.12 92.088,8.91 51.357,-25.2 153.127,-169.18 236.487,-187.91 -133.76,36.52 -144.42,120.84 -263.636,98.55 -119.216,-22.29 -236.651,-92.34 -236.651,-92.34 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: "3.45px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path178"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-0.920568,1164.85)",
    id: "g184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 700.075,1304.47 c 0,0 381.095,-41.18 513.585,0 132.49,41.17 -458.176,38.79 -513.585,0 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: "3.45px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path182"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-71.817,1141.49)",
    id: "g188"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1032.13,
    cy: 1329.11,
    rx: 66.367996,
    ry: 6.7319999,
    id: "ellipse186"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1013.64,1309.86 c 0,0 -315.37,8.35 -276.415,16.21 69.475,14.01 87.486,8.85 126.865,8.83 -94.003,-1.83 -114.459,-25.04 149.55,-25.04 z",
    id: "path190"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1070.38,1309.86 c 0,0 204.46,9.43 122.08,20.35 -82.38,10.91 -347.873,-1 -355.317,1.49 -7.444,2.48 251.597,-5.63 283.357,-5.63 103.72,0 -2.48,-3.31 -50.12,-16.21 z",
    id: "path194"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-14.4662,1142.83)",
    id: "g202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 497.528,507.371 c 0,0 82.037,-109.717 187.832,-82.683",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "8.33px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path200"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 594.322,444.725 c 0,0 16.63,-15.647 45.958,-10.809",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "8.33px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path204"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 474.277,521.646 c 0,0 -74.274,103.523 -47.109,228.537",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "3.33px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path208"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeOutOfReactionChamber);
export default __webpack_public_path__ + "static/media/take-out-of-reaction-chamber.672248a986f8d562b2b021ab406deee5.svg";
export { ForwardRef as ReactComponent };